module.exports = __webpack_public_path__ + "img/mediatheque.0050e7b4.jpg";